// import moment from 'moment';
import moment from 'moment-timezone';

class BaseMitDateTimeService {
  constructor() {
    this.localFormatFull = "MM-DD-YYYY HH:mm:ss";
    this.localFormatFull2 = "MMM/DD/YY h:mm a";
    this.localFormatDayMonthYear1 = "MM-DD-YYYY";
    this.localFormatDayMonthYear2 = "MMM-DD-YYYY";
    this.localFormatTime = "HH:mm:ss";

  }

  isDateTimeFormatValid(dateTimeString){
    return (moment(dateTimeString, this.localFormatFull, true).isValid() === true);
  }

  formatGetDate1(momentDate){
    return moment(momentDate).format(this.localFormatDayMonthYear1).toString();//default to now
  }
  formatGetDate2(momentDate){
    return moment(momentDate).format(this.localFormatDayMonthYear2).toString();//default to now
  }
  formatGetTime(momentDate){
    return moment(momentDate).format(this.localFormatTime).toString();//default to now
  }
  formatGetDateTime(momentDate){
    return moment(momentDate).format(this.localFormatFull).toString();//default to now
  }
  formatGetDateTime2(momentDate){
    return moment(momentDate).format(this.localFormatFull2).toString();//default to now
  }
  formatTimeAgo(momentDate, shortenText){
    shortenText = shortenText || false;
    return moment(momentDate).fromNow(shortenText).toString();//default to now
  }
  getDateNow(){
    return moment().local();
  }

  getCurrentDayOfWeek(targetDateTime){
    return moment(targetDateTime).format('dddd').toLowerCase();
  }

  convertLocalTimeToUTCServerFormat(momentDateTime){
    return momentDateTime.utc().format("YYYY-MM-DD hh:mm A");
  }

  getMyTimezone(){
    return moment.tz.guess();
  }
  getTimezones(){
    return moment.tz.names();
  }

}
export default BaseMitDateTimeService;
